import {Fragment, useEffect, useState} from "react";
import {defaultRecipe} from "../../global/defaults";
import {useLocation} from "react-router";
import {RecipeDataHandler} from "../../logic/db/RecipeDataHandler";
import ControlledForm from "../../reusable/ControlledForm/ControlledForm";
import DefaultSubmissionZone from "../../reusable/ControlledForm/Submissions/DefaultSubmissionZone";
import ListItem from "../../reusable/ListView/ListItem";
import {RecipeModel} from "../../logic/models/RecipeModel";
import ResultZone from "./ResultZone";
import ConverterZone from "./ConverterZone";
import {useTranslation} from "react-i18next";
import {TranslationParser} from "../../translations/TranslationParser";

export const RecipeConverterForm = () => {
    const [recipe, setRecipe] = useState<RecipeModel>(new RecipeModel({recipe: defaultRecipe}))
    const [fetchingData, setFetchingData] = useState<boolean>(true)
    const {t} = useTranslation("common")

    const locations = useLocation().pathname.split('/')

    useEffect(() => {
        RecipeDataHandler.getRecipeByName(locations[locations.length - 1]).then((recipeData) => {
            setRecipe(new RecipeModel({recipe: recipeData}))
            setFetchingData(false)
        }).catch(() => "FAILURE!")
    }, [])

    const onSubmit = (event: any, submission: any) => {
        event.preventDefault()
    }

    const initialValues = {
        ...recipe.toFormData(),
        diameterOut: 10, diameterUnitOut: "cm",
        heightOut: 10, heightUnitOut: "cm",
    }

    const listData = recipe.retrieveListData().filter(tag => tag.label === "mass" || tag.label === "diameter" || tag.label === "height")

    return ( !fetchingData ?
            <div className="recipe-converter-form-wrapper">
                <ControlledForm initialValues={initialValues} onSubmit={onSubmit}>
                    <h3 className="modal-title">{t('convert.convert_recipe')}</h3>
                    <ListItem label={recipe.recipe.name} tags={TranslationParser.parseUnits(t, listData)} actions={<Fragment/>}/>
                    <ConverterZone recipe={recipe}/>
                    <h4 className="results-title">Results:</h4>
                    <ResultZone recipe={recipe}/>
                    <DefaultSubmissionZone submitText={t('convert.convert')}/>
                </ControlledForm>
            </div> : null
    )
}
